/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Activity Service - API client for activity heatmap data
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import api from './api'
import { createLogger } from '../utils/logger'

const logger = createLogger('activityService')

class ActivityService {
  /**
   * Fetch activity heatmap data
   * Returns daily activity aggregated over the past 52 weeks
   * @param {string} userId - Optional user ID (for coach/guardian views)
   * @returns {Promise<Object>} Activity heatmap data with activities and stats
   */
  async getActivityHeatmap(userId = null) {
    try {
      // Use user-specific endpoint if userId provided, otherwise use /me endpoint
      const endpoint = userId ? `/user/${userId}/activity-heatmap` : '/user/activity-heatmap'
      const response = await api.get(endpoint)
      return response.data
    } catch (error) {
      logger.error('Error fetching activity heatmap:', error)
      throw error
    }
  }
}

export default new ActivityService()
